module.exports = __webpack_public_path__ + "static/media/stonks-man.000ad3bc.png";